import script from "./OidoCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./OidoCheckbox.vue?vue&type=style&index=0&id=4dbc08e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dbc08e7"]])

export default __exports__